import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import Cookies from 'js-cookie'
import { handleAlert } from '../functions/handleAlert'

export const getCategory=createAsyncThunk("category",async(args)=>{
  const token = Cookies.get(`${process.env.REACT_APP_TOKEN_NAME}`) 
  const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/category/${args.id}`,{
    headers:{
      Authorization:`Bearer ${token}`
    }
  })
  return res
})

const initialState = {
  category:null,
  isLoading:true
}

export const categoriesSlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
  },
  extraReducers:(builder)=>{
    builder.addCase(getCategory.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCategory.fulfilled, (state, { payload }) => {
      state.category = payload.data
      state.isLoading = false
    })
    builder.addCase(getCategory.rejected, (state, action) => {
      if (action.payload) {
        handleAlert(action.payload.errorMessage , "error") 
      } else {
        handleAlert(action.error.message, "error") 
      }
    })
  }
})

export default categoriesSlice.reducer